






import {Component, Vue, Prop} from 'vue-property-decorator';
import _ from 'lodash';
import {currencies} from "@/libs/money";

@Component
export default class MoneyView extends Vue {
  @Prop()
  readonly value !: {currency: string, amount: number};

  get currencyLabel(): string {
    return _.chain(currencies).find({value: this.value.currency}).get('label', '元').value();
  };

  get amount(): number {
    return _.chain(this.value).get('amount', 0).value();
  }

}
